import { Visibility } from "@/shared/enums/visibility";

interface CellOptions {
	data: {
		translatedVisibility: string;
		accessRights: {
			code: string;
		};
	};
}

interface ColumnConfig {
	caption: string;
	dataField: string;
	dataType?: string;
	format?: string;
	width?: string;
	minWidth?: number;
	visible?: boolean;
	allowHeaderFiltering?: boolean;
	cellTemplate?: (container: HTMLElement, options: CellOptions) => void;
}

export const getRecyclingGlossaryColumns = (
	t: (key: string) => string,
): ColumnConfig[] => {
	return [
		{
			caption: t("glossary.name"),
			dataField: "title",
			minWidth: 300,
			allowHeaderFiltering: false,
		},
		{
			caption: t("glossary.description"),
			dataField: "shortDescription",
			minWidth: 400,
			allowHeaderFiltering: false,
		},
		{
			caption: t("glossary.glossary-owner"),
			dataField: "owner.name",
			minWidth: 240,
		},
		{
			caption: t("glossary.visibility"),
			dataField: "accessRights.code",
			minWidth: 150,
			visible: true,
			cellTemplate: (container: HTMLElement, options: CellOptions): void => {
				renderVisibilityChip(container, options);
			},
		},
		{
			caption: t("glossary.publisher"),
			dataField: "publisher.name",
			minWidth: 240,
		},
		{
			caption: t("glossary.created"),
			dataField: "created",
			dataType: "datetime",
			format: "dd/MM/yyyy HH:mm",
			minWidth: 240,
		},
		{
			caption: t("glossary.updated"),
			dataField: "modified",
			minWidth: 240,
			dataType: "datetime",
			format: "dd/MM/yyyy HH:mm",
			allowHeaderFiltering: false,
		},
	];
};

export const renderVisibilityChip = (
	container: HTMLElement,
	options: CellOptions,
): void => {
	const translated = options.data.translatedVisibility;
	const visibilityKey = options.data.accessRights.code;

	if (
		visibilityKey === Visibility.PUBLIC ||
		visibilityKey === Visibility.PRIVATE ||
		visibilityKey === Visibility.RESTRICTED
	) {
		const wrapperElement = document.createElement("div");
		wrapperElement.classList.add("visibility-with-dot");

		const dotElement = document.createElement("i");
		dotElement.classList.add("mdi", "mdi-circle", "content-circle");

		const textElement = document.createElement("span");
		textElement.textContent = translated;

		if (visibilityKey === Visibility.PUBLIC) {
			dotElement.classList.add("content-visibility-circle-green");
		} else if (visibilityKey === Visibility.PRIVATE) {
			dotElement.classList.add("content-visibility-circle-red");
		} else if (visibilityKey === Visibility.RESTRICTED) {
			dotElement.classList.add("content-visibility-circle-orange");
		}

		wrapperElement.appendChild(dotElement);
		wrapperElement.appendChild(textElement);
		container.appendChild(wrapperElement);
	}
};
